/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import nebula from './nebula/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

/**
 * jsbridge准备工作完成。支持【nebula容器(支付宝App)】
 * @example
 * import { jsbridgeReady } from '@alife/cn-uni-api';
 *
 * jsbridgeReady()
 *  .then(res => res)
 *  .catch(err => err)
 *
 * @author 敬文
 */
var jsbridgeReady = extend({
    web: {
        nebula: nebula,
    },
});

export { jsbridgeReady };
